<div class="bg-light px-3">
  <div class="row sticky-top bg-white" style="top: 5.5rem">
    <div class="col-md-12">
      <app-alerting></app-alerting>
    </div>
    <div class="col-md-12">
      <app-action-nav-bar>
        @if (canEdit()) {
          <div class="btn-group fieldset enabled">
            <button type="submit" class="btn btn-info" tabindex="-1" form="harbour_dues_form">Save and send
            </button>
            <button type="button" class="btn btn-info dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <span class="visually-hidden">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a id="save" class="dropdown-item text-success" href="#" role="button"
                 (click)="$event.preventDefault(); saveDraft()">
                <i class="fa fa-save" aria-hidden="true"></i> Save
              </a>
            </div>
          </div>
        }
      </app-action-nav-bar>
    </div>
    <div class="col-md-12 bg-light border-bottom">
      <div class="row page-section px-0">
        <div class="col"></div>
        <div class="col-8">
          @if (declarationTabs.length > 1) {
            <app-tab-panel (tabChange)="onTabChange($event)" [sticky]="true"
                           [alwaysRender]="true">
              @for (t of declarationTabs; track t) {
                <app-tab-item>
                  <span class="tab-item">{{ invoicePeriod(t.invoiceStart, t.invoiceEnd) }}</span>
                </app-tab-item>
              }
            </app-tab-panel>
          }
        </div>
        <div class="col"></div>
      </div>
    </div>
  </div>
  <app-tab-panel>
    <app-tab-item [templateRef]="details">
      <span class="tab-item">Details</span>
      <ng-template #details>
        <form class="page-section fieldset container-harbour-dues d-flex flex-column gap-5  my-5" id="harbour_dues_form"
              name="harbour_dues_form" [formGroup]="form"
              [ngClass]="{'was-validated': showValidationErrors, 'disabled' : !canEdit(), 'enabled': canEdit()}"
              (ngSubmit)="declare()">
          @if (appContext.isAdmin()) {
            <app-harbour-dues-admin-amsterdam [declaration]="selectedDeclaration"></app-harbour-dues-admin-amsterdam>
          }
          <div class="card">
            <div class="card-body p-5">
              <div class="h5">Harbour dues {{ port }} {{ getDeclarationPeriod() }}</div>
              @if (isAvailable()) {
                <p>Enter tariff discounts for the port authority in {{ port }}. To view what discounts are
                  available,
                  please
                  <a href="{{getTariffLink()}}" target="_blank"
                     class="link-primary text-decoration-underline">check out this page.</a>
                </p>
                @if (declarationSent()) {
                  <ng-container [ngTemplateOutlet]="sent"/>
                } @else {
                  <ng-container [ngTemplateOutlet]="not_sent"/>
                }
              } @else {
                <ng-container [ngTemplateOutlet]="notAvailable"/>
              }
            </div>
          </div>
          @if (declarationSelected()) {
            <div class="card">
              <div class="card-body p-5">
                <app-discount-amsterdam [discountForm]="form.controls.discount"
                                        [exemption]="form.controls.exemption"
                                        [selectedType]="form.controls.selectedType"
                ></app-discount-amsterdam>
              </div>
            </div>

            @if (declarationHasBerthVisits()) {
              <div class="card">
                <div class="card-body p-5">
                  <div class="h1 mb-2">Berth details</div>
                  <p class="mb-4">
                    <span>Berth names and order are taken from </span>
                    <a [routerLink]="['/details', context.visit.crn, 'visit']"
                       class="link-primary text-decoration-underline">
                      the timeline.</a>
                  </p>
                  <div class="row g-5">
                    @for (b of selectedDeclaration.visit.berthVisits; track b; let i = $index) {
                      <div class="col-12 gap-5">
                        <div class="h2 mb-3">{{ i + 1 + ' - ' + b.berth.name }}</div>
                        <div class="row g-4">
                          <app-form-field class="col-12 col-md-4" label="Arrival date & time" [includeMargin]="false"
                                          [value]="berthVisitArrivalDateTime(b.ata)"
                                          [editMode]="false"></app-form-field>
                          <app-form-field class="col-12 col-md-8" label="Stay duration" [includeMargin]="false"
                                          [value]="berthVisitDuration(b.ata, b.atd)"
                                          [editMode]="false"></app-form-field>
                          <app-form-field class="col-12" label="Visit purpose(s)" [includeMargin]="false"
                                          [value]="b.visitPurposes.map(PortvisitUtils.enumFormatter).join(', ')"
                                          [editMode]="false"></app-form-field>
                          @if (goodsLoadedAt(i) || goodsDischargedAt(i)) {
                            <app-form-field class="col-6" label="Stevedore" [includeMargin]="false">
                              <app-search [formControl]="form.controls.berthVisits.at(i).controls.stevedore"
                                          [required]="form.controls.berthVisits.at(i).controls.dischargedGoods.length > 0 ||
                                  form.controls.berthVisits.at(i).controls.loadedGoods.length > 0"
                                          [optionsProvider]="stevedores" [inputFormatter]="formatHarbourDuesStevedore"
                                          [placeholder]="'Type to search'"></app-search>
                            </app-form-field>
                          }
                        </div>
                        @if (goodsLoadedAt(i) || goodsDischargedAt(i)) {
                          <div class="row g-5 mt-0">
                            @if (goodsDischargedAt(i)) {
                              <div class="col-12">
                                <app-cargo-list-amsterdam [type]="'discharge'"
                                                          [list]="form.controls.berthVisits.at(i).controls.dischargedGoods"
                                                          [index]="i"
                                                          [terminalCode]="b.berth.terminalCode"
                                                          (copyDataConfirmed)="handle($event)"
                                ></app-cargo-list-amsterdam>
                              </div>
                            }
                            @if (flatsOrContainersDischargedAt(i)) {
                              <div class="col-12">
                                <app-equipment-list-amsterdam
                                  [list]="form.controls.berthVisits.at(i).controls.dischargedCargoCounts"
                                  [type]="'discharge'"></app-equipment-list-amsterdam>
                              </div>
                            }
                            @if (goodsLoadedAt(i)) {
                              <div class="col-12">
                                <app-cargo-list-amsterdam [type]="'loading'"
                                                          [list]="form.controls.berthVisits.at(i).controls.loadedGoods"
                                                          [index]="i"
                                                          [terminalCode]="b.berth.terminalCode"
                                                          (copyDataConfirmed)="handle($event)">
                                </app-cargo-list-amsterdam>
                              </div>
                            }
                            @if (flatsOrContainersLoadedAt(i)) {
                              <div class="col-12">
                                <app-equipment-list-amsterdam
                                  [list]="form.controls.berthVisits.at(i).controls.loadedCargoCounts"
                                  [type]="'loading'"></app-equipment-list-amsterdam>
                              </div>
                            }
                          </div>
                          @if (combinedLoadingWeightExceedsVesselDeadWeight()) {
                            <div class="mt-5">
                              <app-status-alert type="warning">Combined weight of loading cargo minus discharge cargo
                                across
                                berths cannot exceed {{ context.getVesselDeadWeightKg() }} kg
                              </app-status-alert>
                            </div>
                          }
                          @if (combinedDischargeWeightExceedsVesselDeadWeight()) {
                            <div class="mt-5">
                              <app-status-alert type="warning">Combined weight of discharge cargo minus loading cargo
                                across
                                berths cannot exceed {{ context.getVesselDeadWeightKg() }} kg
                              </app-status-alert>
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          }
        </form>
      </ng-template>
    </app-tab-item>
    <app-tab-item [templateRef]="history">
      <span class="tab-item">History</span>
      <ng-template #history>
        <div class="container-harbour-dues d-flex flex-column gap-5 my-5">
          <div class="card">
            <div class="card-body p-5">
              <div class="h5">History</div>
              <app-harbour-dues-history-amsterdam
                [declaration]="selectedDeclaration">
              </app-harbour-dues-history-amsterdam>
            </div>
          </div>
        </div>
      </ng-template>
    </app-tab-item>
  </app-tab-panel>
</div>

<ng-template #notAvailable>
  @if (!hasArrived()) {
    <p>The harbour dues declaration will be available for
      filing once the ATA (Actual Time of Arrival) has been registered.</p>
  } @else {
    <p>Filing of the harbour dues declaration has been assigned
      to {{ context.savedVisit.financialDeclarant.fullName }}.</p>
  }
  <p>To view or change the financial declarant, go to the <a
    [routerLink]="['/details', context.visit.crn, 'authorise']"
    class="pe-auto link-primary text-decoration-underline">'Authorise Organisations' tab.</a></p>
</ng-template>

<ng-template #not_sent>
  <div class="h2">Vessel status</div>
  @if (context.hasDeparted() && declarationSelected()) {
    <div>
      Departed {{ visitDepartureOrArrivalDateTime(selectedDeclaration.visit.atd) }}
    </div>
  } @else {
    @if (hasArrived() && declarationSelected()) {
      <div>
        Arrived {{ visitDepartureOrArrivalDateTime(selectedDeclaration.visit.ata) }}
      </div>
    }
  }
</ng-template>

<ng-template #sent>
  <div class="mb-3">
    <app-task-message-status [messageStatus]="declarationTaskMessageStatus()"
                             [customLabel]="declarationRejectionReason() ? 'Rejected: ' + (declarationRejectionReason()) : null"
                             [reason]="declarationRejectionReason()"
                             [showTooltip]="false"></app-task-message-status>
  </div>
  @if (declarationAccepted()) {
    <div class="always-enabled">
      <button type="button" class="btn btn-outline-primary" (click)="downloadPdf()">
        <i class="fa-solid fa-download me-2"></i>
        <span>Download PDF</span>
      </button>
    </div>
  }
</ng-template>
